import React from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'

const PublicSupplierRoute = ({
	isAuthenticated,
	component: Component,
	client,
	...rest
}) => {
	return (
		<Route
			{...rest}
			component={(props) =>
				isAuthenticated ? (
					<Redirect to='/supplier/supplier_dashboard' />
				) : (
					<Component {...props} />
				)
			}
		/>
	)
}

const mapStateToProps = (state) => ({
	supplier: state.app.supplier,
	isAuthenticated: !!state.app.supplier,
})

export default connect(mapStateToProps)(PublicSupplierRoute)
